import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

export const documentsRename = {
  namespaced: true,
  state,
  actions,
  mutations,
}
